import {
	HOMEPAGE_SETTINGS_UPLOAD_START,
	HOMEPAGE_SETTINGS_UPLOAD_ERROR,
	HOMEPAGE_SETTINGS_UPLOAD_SUCCESS
} from '../../constants/index';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';
import { showToaster } from '../../helpers/toastrMessgaes/showToaster';
import { updateHomePageCityMutation as mutation } from '../../lib/graphql';

export const updateHomepageSettingsCity = (values) => {
	return async (dispatch, getState, { client }) => {

		try {
			dispatch(setLoaderStart('CitySettingsForm'));
			dispatch({
				type: HOMEPAGE_SETTINGS_UPLOAD_START
			})

			const { data } = await client.mutate({
				mutation,
				variables: {
					citySectionTitle1: values?.citySectionTitle1 && values.citySectionTitle1[0].value,
					citySectionContent1: values?.citySectionContent1,
					dynamicCategoryTitle: values?.citySectionTitle1
				}
			})

			if (data?.updateHomePageCity?.status == 200) {
				dispatch({
					type: HOMEPAGE_SETTINGS_UPLOAD_SUCCESS
				})
				showToaster({ messageId: 'updateCitySuccess', toasterType: 'success' });
			} else {
				dispatch({
					type: HOMEPAGE_SETTINGS_UPLOAD_ERROR
				})
				showToaster({ messageId: 'errorMessage', requestContent: { content: data?.updateHomePageCity?.errorMessage }, toasterType: 'error' });
			}
			dispatch(setLoaderComplete('CitySettingsForm'));
		} catch (err) {
			dispatch({
				type: HOMEPAGE_SETTINGS_UPLOAD_ERROR
			})
			showToaster({ messageId: 'catchMessage', requestContent: { content: err }, toasterType: 'error' });
			dispatch(setLoaderComplete('CitySettingsForm'));
		}
	}
}